module.exports = __webpack_public_path__ + "img/zhiyao3.5281a294.png";